import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../../core/auth/auth.service';

/**
 * Guard da Área Administrativa.
 *
 * Regras:
 * - Não utiliza TenantService.
 * - Não verifica tenantId.
 * - Verifica token JWT + role 'Acesso-Admin' extraída do payload do JWT.
 * - Se o usuário não estiver carregado ainda (ex: após F5), carrega via AuthService e então verifica.
 */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!localStorage.getItem('hub_access_token')) {
    return router.createUrlTree(['/auth/login']);
  }

  // Lê role diretamente do JWT — não depende de UserDTO.role
  if (auth.isAdmin()) {
    return true;
  }

  // Usuário não carregado ainda (ex: F5): carrega para hidratar o signal, mas
  // a decisão de acesso já vem do JWT decodificado.
  const user = auth.user();
  if (!user) {
    return auth.loadCurrentUser().pipe(
      map(() => (auth.isAdmin() ? true : router.createUrlTree(['/auth/login'])))
    );
  }

  return router.createUrlTree(['/auth/login']);
};
